export default __webpack_public_path__ + "static/cephaloPods-ca513d6bde1c5b5a844889beab496291.jpeg";